<template>
  <div>
    <div class="width100">
      <headerBackground v-bind="testData" />
      <div class="container">
        <div class="row">
          <div class="col-lg-8 col-md-10 mx-auto">
            <div class="pb-4 text-start">
              <h2 @click="goBack" class="go-back">Назад</h2>
            </div>
            <div v-if="result" class="pb-5 text-start">
              <h2>
                <div :style="'font-weight:bold; color:' + [result.persent > 51 ? 'green' : 'red'] + ';'">Ваш результат: {{
                  result.correct }} из {{ result.total + ' (' + result.persent + '%)' }}
                </div>
              </h2>
              <div v-if="result.persent > 51">
                <div v-if="!pass">
                  <b-button size="lg" variant="primary" class="mx-2 my-4" @click="getPass()">Подтвердить
                    результат</b-button>
                  <h2>Если не подтвердить результат, пройденый тест не сохраниться и придется проходить его снова!</h2>
                </div>
                <h2 v-else>Теперь это окончательный результат.</h2>
              </div>
              <div v-else>
                <h2>Тест считается пройденым при результате от 51%</h2>
              </div>
              <div v-if="result.persent == 100">
                <h2>За успешное освоение знаний, вас ждет награда!</h2>
                <b-button size="lg" variant="primary" class="mx-2 my-4" @click="getPass(); $router.push('/space')">ПРИЗ</b-button>
              </div>
            </div>
            <div v-if="warning" class="pb-5 text-start">
              <h2>
                <div style="color: red;" v-html="warning"/> 
              </h2>
            </div>
            <div v-if="correctAnswer" class="pb-5 text-start">
              <h2>
                <div style="color: green;"> {{ correctAnswer }}
                </div>
              </h2>
            </div>
            <div class="pb-2 text-start"
              v-if="questionsList !== undefined && questionsList.length > 0 && (current + 1) <= questionsList.length">
              Вопрос {{ current + 1 }} из {{ questionsList.length }}
            </div>
            <div v-if="bigAnswer" v-html="bigAnswer">
            </div>
            <img v-if="questionImage" :src="'/' + questionImage" class="w-100 pb-4" alt="">
            <div class="pb-5 text-start">
              <h2>
                <div v-if="questionText !== undefined && questionText.length > 0 && questionText[0].question"
                  v-html="questionText[0].question">
                </div>
              </h2>
            </div>
            <div v-if="answersText !== undefined && answersText.length > 1">
              <div v-for="(answer, index) in answersText" :key="index" class="text-start">
                <div class="pb-3">
                  <h3>
                    <b-form-checkbox v-model="answersText[index].correct" value="1" unchecked-value="0"> {{
                      answer.answer
                    }}</b-form-checkbox>
                  </h3>
                </div>
              </div>
            </div>
            <div v-else>
              <div v-for="(answer, index2) in answersText" :key="index2" class="text-start">
                <div class="pb-3">
                  <h3>
                    <b-form-group id="input-group-2" label="Введите ответ:" label-for="input-2">
                      <b-form-input id="input-2" v-model="answer.answer" placeholder="Ответ" required></b-form-input>
                    </b-form-group>
                  </h3>
                </div>
              </div>
            </div>
            <b-button v-if="questionText !== undefined && questionText.length > 0" size="lg" variant="primary"
              class="mx-2 my-4" @click="current++; setAnswerQuestions();">Ответить</b-button>
          </div>
        </div>
      </div>
    </div>
    <cabinetFooter />
  </div>
</template>
<script>
import headerBackground from '@/components/headerBackground.vue'
import cabinetFooter from '@/components/cabinetFooter.vue'
// import md5 from 'js-md5'
import { Base64 } from 'js-base64';

export default {
  components: {
    headerBackground,
    cabinetFooter
  },
  data() {
    return {
      testId: null,
      questionsList: {},
      questionId: null,
      current: 0,
      questionText: {},
      answersText: {},
      selected: [],
      correctAnswer: null,
      warning: null,
      questionImage: null,
      bigAnswer: null,
      result: null,
      testData: null,
      pass: 0
    }
  },
  watch: {
    $route: {
      handler: function () {
        this.testIdRefresh()
      },
      deep: true
    }
  },
  mounted() {
    if (this.$route.params.testId) {
      this.testIdRefresh();
      this.questionsList = {};
      this.axios
        .get(this.$store.getters.URL + '/api/test/' + this.$route.params.testId)
        .then(response => (this.questionsList = response.data.questionsList,
          this.persentCount(response.data.result),
          this.testData = response.data.testData,
          this.pass = response.data.pass,
          this.$store.commit('reDirect', response.data.redirect),
          this.setAnswerQuestions()
        ));

    }
  },
  methods: {
    backOne() {
      if (this.current > 0) {
        this.current--;
      }
      this.setAnswerQuestions();
    },
    addCorrectFalse(array) {
      if (array !== undefined && array.length > 0) {
        array.forEach((value) => {
          value.question_id = this.questionsList[this.current].id;
          value.correct = "0";
        });
        return array;
      }
    },
    b64d(string) {
      return Base64.decode(string);
    },
    testIdRefresh() {
      if (this.$route.params.testId) {
        this.testId = this.$route.params.testId;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    persentCount(result) {
      if (result) {
        this.result = result;
        this.result.persent = Math.round(result.correct / result.total * 100);
        if (isNaN(this.result.persent)) {
          this.result.persent = 0;
        }
      }
    },
    setAnswerQuestions() {
      if (this.questionsList !== undefined) {
        if (this.questionsList.length > this.current) {
          this.questionId = this.questionsList[this.current].id;
        } else {
          this.questionId = 0;
        }
        this.axios.post(this.$store.getters.URL + '/api/question/',
          {
            data: {
              answersText: this.answersText,
              testId: this.testId,
              questionId: this.questionId,
              current: this.current
            }
            // , withCredentials: true,
            // //, headers: { "Cookie": document.cookie },
            // // ,
            // headers: {
            //   "Content-Type": "text/plain"
            //   // "Policy": 'no-referrer-when-downgrade',
            //   // "Content-type": "application/json; charset=UTF-8",
            //   // "Content-type": "application/x-www-form-urlencoded",
            // }
          })
          .then(response => (
            this.questionText = {},
            this.answersText = {},
            this.questionText = response.data.questionText,
            this.answersText = this.addCorrectFalse(response.data.answersText),
            this.$store.commit('popUpWiev', response.data.popUp),
            this.$store.commit('popUpTitleWiev', response.data.correctAnswer),
            this.$store.commit('popUpTextWiev', response.data.bigAnswer),
            this.warning = response.data.warning,
            this.questionImage = response.data.questionImage,
            this.persentCount(response.data.result),
            response.data.backOne ? this.backOne() : null
          ))
          // .catch(function (error) {
          //   console.log(error);
          // })
          ;
      }
    },
    getPass() {
      this.axios.post(this.$store.getters.URL + '/api/testpass/',
        {
          data: {
            testId: this.testId,
          }
        })
        .then(response => (
          this.pass = response.data.pass,
          this.warning = response.data.warning,
          response.data.backOne ? this.backOne() : null
        ))
        // .catch(function (error) {
        //   console.log(error);
        // })
        ;
    }
  },
}
</script>
<style>
/* #app .custom-control-input {
  display: inline-block;
} */
.custom-control-input,
.form-control {
  box-shadow: 0px 0px 1px 1px #48015a;
}

.form-control {
  margin-top: 20px;
}


.custom-control-input:hover,
.custom-control-input:active,
.form-control:hover,
.form-control:active,
.form-control:focus {
  box-shadow: 0px 0px 13px 4px #48015a78;
  outline: 0 none;
}

.custom-control-label {
  width: calc(100% - 60px);
  cursor: pointer;
}

.custom-control-input {
  width: 30px;
  height: 30px;
  margin-right: 30px;
  /* margin-top: 10px; */
  vertical-align: top;
  cursor: pointer;
}

/* .custom-checkbox {} */
</style>
